<template>
    <div class="welcome-container">
      <div class="welcome-content">
        <h1 class="title">YggDat</h1>
        <p class="subtitle">Lagring av forskningsdata tett på lab</p>
  
        <button v-if="!loggedInUser" @click="login" class="login-button">Logg inn med Microsoft</button>
        <router-link v-else to="/projects" class="enter-button">Gå til prosjektoversikt</router-link>
      </div>
    </div>
  </template>
  
  <script>
  import { msalInstance } from '@/services/msalInstance';
  import { mapState, mapMutations } from 'vuex';
  import axios from 'axios';
  import { API_ENDPOINTS } from '@/services/config';
  
  export default {
    computed: {
      ...mapState(['loggedInUser']),
    },
    methods: {
      ...mapMutations(['setLoggedInUser']),
      async login() {
        try {
            const response = await msalInstance.loginPopup({ scopes: ['user.read'] });
            const account = response.account;

            const entraUser = {
            entra_id: account.homeAccountId,
            username: account.username,
            name: account.name,
            };

            const backendUser = await axios.post(API_ENDPOINTS.entraUser, entraUser);

            this.setLoggedInUser({
            id: backendUser.data.id,
            name: backendUser.data.name,
            username: backendUser.data.username,
            entra_id: entraUser.entra_id,
            });
        } catch (error) {
            console.error('Login failed', error);
        }
        },
    },
  };
  </script>
  
  <style scoped>
  .welcome-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(to bottom right, #e3f2fd, #f5f5f5);
    padding: 2rem;
  }
  
  .welcome-content {
    text-align: center;
    max-width: 600px;
    background-color: white;
    padding: 3rem;
    border-radius: 20px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
  
  .title {
    font-size: 3rem;
    font-weight: 700;
    color: #003366;
    margin-bottom: 1rem;
  }
  
  .subtitle {
    font-size: 1.25rem;
    color: #444;
    margin-bottom: 2rem;
  }
  
  .login-button,
  .enter-button {
    background-color: #0078d4;
    color: white;
    font-size: 1rem;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    text-decoration: none;
  }
  
  .login-button:hover,
  .enter-button:hover {
    background-color: #005fa3;
  }
  </style>
  